<template>
  <div 
    data-component="Widget/UploadImage"
    class="upload-image-widget"
    @click="handleClick"
  >
    <i class="ico camera"></i>
    <span class="upload-text">Ajouter une photo</span>
  </div>
</template>

<script>
export default {
  name: 'UploadImage',
  
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  methods: {
    handleClick(event) {
      this.$emit('click', event)
    },
  },
}
</script>

<style lang="scss" scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
